const getRwgTokenFromCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)_rwgToken=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : undefined;
};

export const trackGoogleConversion = () => {
  const partnerId = 20004431;
  const endpoint = 'https://www.google.com/maps/conversion/debug/collect';
  const rwgToken = getRwgTokenFromCookie();

    if (rwgToken) {
        fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify({
                conversion_partner_id: partnerId,
                rwg_token: rwgToken,
                merchant_changed: 1
            })
        });
    }
};
